import React, { useState, useEffect } from "react";
import { getDiagnosisList, getReportList } from "../../ERXViewApiHandler";
import {
  GET_DIAGNOSIS_LIST,
  GET_REPORT_LIST,
} from "../../ERXViewApiHandler/apiConstants";
import "./prEXView.scss";
import CreatableSelectWithDescription from "../../common/CreatableSelectWithDescription";
import AddIcon from "../../../../assets/rx_add.svg";
import useDebounce from "../../common/debounce";
import { ERX_LIST_HEADER_KEY } from "../../ERXConstants/constants";

const PREXView = (props) => {
  const { element, reportList, handleReport, handleUpdateAPICall } = props;
  const [reportOption, setReportOption] = useState([]);
  const [maxApiCall, setMaxApiCall] = useState(1);
  const [pageNo, setPageNo] = useState(1);
  const [selectedIndex, setSelectedIndex] = useState();

  const debounceForReportList = useDebounce(reportList, 500);

  useEffect(() => {
    if (debounceForReportList?.call_api) {
      handleUpdateAPICall();
    }
  }, [debounceForReportList]);

  useEffect(() => {
    setPageNo(1);
  }, [selectedIndex]);

  const getDiagnosisListAPICall = async (key, searchString, pageNo, type) => {
    let reqParams = {
      search_string: searchString,
      page_no: pageNo,
    };
    const diagnosisListResponse = getReportList(GET_REPORT_LIST, reqParams); //Fetch API Data
    diagnosisListResponse.then(([res, count, error]) => {
      if (!error) {
        if (res?.length > 0) {
          if (type === "search") {
            setReportOption([...res]);
          } else {
            setReportOption([...reportOption, ...res]);
          }
          let maxCount = Math.ceil(count / 20);
          setMaxApiCall(maxCount);
          setSelectedIndex(key);
        } else {
          setSelectedIndex();
        }
      }
    });
  };

  const handleSearch = (key, value, pageno, type) => {
    if (selectedIndex !== key) {
      setPageNo(1);
    }
    if (value?.length > 0) {
      getDiagnosisListAPICall(key, value, pageno, type);
    } else {
      setMaxApiCall(0);
      setReportOption([]);
      setSelectedIndex();
    }
  };

  const handleSelect = (key, value) => {
    let data = [...reportList.value];
    data[key] = { ...data[key], title: value?.title, value: value };
    handleReport(true, [...data]);
    setReportOption([]);
    setSelectedIndex();
  };

  const handleOnChange = (key, val) => {
    let value = val?.length > 0 ? val[0] : { title: "", id: 1 };
    if (value?.length === 0) {
      value.title = "";
      value.id = 1;
    }
    let data = [...reportList.value];
    data[key] = { ...data[key], title: value?.title, value: value };
    handleReport(true, [...data]);
    setReportOption([]);
    setSelectedIndex();
  };

  const handleDescriptionText = (key, value) => {
    let data = [...reportList.value];
    data[key] = { ...data[key], description: value };
    handleReport(true, [...data]);
  };

  const handleAddDiagnosis = () => {
    let data = [...reportList.value];
    let obj = {
      id: data?.length + 1,
      title: "",
      description: "",
      value: { id: data?.length + 1 },
    };
    data.push(obj);
    handleReport(true, [...data]);
  };

  const handleRemove = (key) => {
    let data = [...reportList.value];
    data.splice(key, 1);
    handleReport(true, [...data]);
  };

  const renderAddReportsButton = () => {
    return (
      <button className="add-column-btn py-2" onClick={handleAddDiagnosis}>
        <img src={AddIcon} alt="" className="mx-2" />
        Add Finding{" "}
      </button>
    );
  };
  const handleCustomInput = (key, value) => {
    let obj = {
      title: value?.value,
      ...value,
    };
    handleSelect(key, obj);
  };
  const renderReportUI = () => {
    return (
      <div id={element.name}>
        {reportList.value.map((data, index) => (
          <CreatableSelectWithDescription
            key={index}
            name={index}
            sectionName={ERX_LIST_HEADER_KEY.REPORT}
            inputLabel={index + 1}
            options={reportOption}
            menuIsOpen={selectedIndex === index ? true : false}
            value={data?.value}
            hideInput={data?.title}
            textAreaPlaceholder={"Findings"}
            textAreaMaxLength={500}
            descriptionValue={data?.description}
            handleSearch={handleSearch}
            handleSelect={handleSelect}
            handleOnChange={handleOnChange}
            handleDescriptionText={handleDescriptionText}
            handleRemove={handleRemove}
            maxApiCall={maxApiCall}
            setPageNo={setPageNo}
            pageNo={pageNo}
            closeMenu={(ind) => {
              setSelectedIndex("");
              let dup = [...reportList.value];
              dup[ind].menuIsOpen = false;
              handleReport(true, [...dup]);
            }}
            handleCustomInput={handleCustomInput}
          />
        ))}
        <div className="d-flex justify-content-end">
          {renderAddReportsButton()}
        </div>
      </div>
    );
  };

  return <div className={"prEx-container"}>{renderReportUI()}</div>;
};

export default PREXView;
